module.exports = __webpack_public_path__ + "static/media/04.bd58e098.jpg";